import services from "@/services";
import moment from "moment";
import axios from "axios";

const state = {
  items: [],
  data: {},
  successInput: false,
};

const getters = {
  Items: (state) => state.items,
  Detail: (state) => state.data,
  ShipmentLogs : (state) => {
    let logs = state.data.data.length > 0 ? state.data.data[0].logs : []

    logs.map(x => {
      x.created_at = moment(x.created_at).locale("Id")

      return x
    })

    logs = logs.sort((a, b) => (a.created_at < b.created_at) ? 1 : -1)
    return logs
  }
};

const mutations = {
  setItems: (state, items) => {
    state.items = items;
  },
  setDetail: (state, data) => {
    state.data = data;
  },
  setStatusSubmit: (state, status) => {
    state.successInput = status;
  },
};

const actions = {
  getAllOrder({ commit, dispatch }, param){
    services.setHeader();
    dispatch("setLoadingTable", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("order", param)
        .then((response) => {
          commit("setItems", response.data.data.items);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingTable", false, { root: true })
        })
    });
  },
  getAllOrderSeller({ commit, dispatch }, param){
    services.setHeader();
    dispatch("setLoadingTable", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("orderseller", param, {parseArray: true})
        .then((response) => {
          commit("setItems", response.data.data.items);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingTable", false, { root: true })
        })
    });
  },
  getOneOrder({ commit, dispatch }, payload){
    let param = {}
    if(payload.order_seller_id) param.order_seller_id = payload.order_seller_id
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("order/"+payload.id, param)
        .then((response) => {
          commit("setDetail", response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  getShipmentStatus({ commit, dispatch },payload) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("shipmentstatus",payload)
        .then((response) => {
          commit("setDetail", response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  createOrderPaid({ commit }, payload) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .post("orderpaid", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeStatusOrder({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("orderpaid", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  changeStatusOrderSeller({commit}, payload){
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .put("orderseller/"+payload.id+"/status", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  forceDeliveredOrderSeller({ commit, dispatch }, payload){
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("orderseller/forcedelivered", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  cancelOrderSeller({ commit, dispatch },payload){
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("orderseller/cancel", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  cancelOrderSellerViaBuyerApi({ commit, dispatch },payload){
    let buyerUrl = process.env.VUE_APP_BUYER_API
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      axios
        .post(buyerUrl+"callback/ordersellercancel", payload, {
        })
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  processOrderSeller({ commit, dispatch },payload){
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("orderseller/process", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  createAWB({ commit, dispatch }, payload){
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("shipment", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  forceShipping({ dispatch }, payload){
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .put("force-shipping", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  changeOrderAWB({ commit, dispatch }, payload){
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .put("airwaybill", payload)
        .then((response) => {
          commit("setStatusSubmit", true);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  getAllCancelation({ dispatch }) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("ordercancelreason")
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  updateCancelReason({ commit, dispatch }, param) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .put("ordercancelreason", param)
        .then((response) => {
          commit();
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  getTmeSlot({ commit, dispatch },param) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("timeslot", param)
        .then((response) => {
          commit("setItems", response.data.data.items);
          resolve(response.data.data.items);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
